import React from 'react';
import { healthcareSupport } from './support/healthcare';

const CopayAssistance = ({ name }) => {
  const info = healthcareSupport[name];
  console.log(info, name);

  if (!info) return null;

  return (
    <div>
      <div className="mt-10 text-2xl font-bold">{info.title}</div>

      <p className="my-2">{info.description}</p>

      <div className="mt-10 font-bold">{info.eligibilityCriteria.title}</div>

      <ul className="my-2 list-disc ml-6">
        {info.eligibilityCriteria.items.map((item, index) => (
          <li key={index}>{item.label}</li>
        ))}
      </ul>

      {info.eligibilityCriteria.note && (
        <p className="my-2">{info.eligibilityCriteria.note}</p>
      )}

      <div className="font-bold mt-4">{info.restrictions.title}</div>

      <ul className="my-2 list-disc ml-6">
        {info.restrictions.items.map((item, index) => (
          <li key={index}>{item.label}</li>
        ))}
      </ul>
    </div>
  );
};

export default CopayAssistance; 